import { PageLinks } from "./page-links";

export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "Manchester";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/, /g, 'and ').replace(/ /g, '-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g, '-');

export const defaultResult_Link = "/find-a-property/";

export const site_name = process.env.GATSBY_SITE_NAME;
export const site_url = process.env.GATSBY_SITE_URL;


export const site_bviewing_agent_id = "";

export const IsAllAgentReview = true;
export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;

export const hasPropertyCloud = (process.env.GATSBY_ENABLE_PROPERTYCLOUD || null) === '1' ? true : false;

export const LettingsAdminEmail = false;

export const branch_filter = true;
export const Default_View = "List"

export const search_result_sidebar = true;
export const slider_count = 3;
export const news_slider_count = 3;

export const officeStyle = "Grid"

export const epdqID = "";
export const shasign_pass = "";

export const SimilarProperty_FullWdth = true;

export const currency_converter = false;

export const viewing_btn_text = "Arrange a Viewing";

export const apply_btn_text = "Apply for this role";

export const search_box_placeholder = "Street, area or postcode";

export const Default_Map_Position = {
    lat: 55.9533,
    lng: -3.1883
};

export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";

export const footerVatDetails = "Julian Wadden a subsidiary of Thornley Groves registered in England & Wales<br />Registered office address: 70 St. Mary Axe, London, EC3A 8BE<br />Registered company number: 05584761. VAT Number: 897231391<br />Part of Lomond";

export const mortgage_text = "These results are not provided by NatWest and are only indicative based on a repayment mortgage product. The interest rate has been assumed to stay the same for the selected mortgage term. Repayments will be subject to the product provided and your circumstances. Your home or property may be repossessed if you do not keep up repayments on your mortgage."

export const valuation_thanks = `<p>We’ll be in touch shortly to arrange a suitable time for one of our Julian Wadden experts to visit and assess your property.<br /><br />Looking for a property to buy? Find it <a href="/${PageLinks.property_for_sale}/">here</a></p>
<h4>Your Julian Wadden Account</h4>
<p>Receive a tailored report with up-to-date insights into your home's value and the current market in your area.</p>`

export const marketing_consent = `I agree to receive property-related news, updates and communications from ${process.env.GATSBY_SITE_NAME}. I understand I can unsubscribe at any time.`

export const terms_condition_text = `By submitting this form, you confirm that you agree to our website <a href="${PageLinks.terms_condition}" target="_blank">terms and conditions</a>, <a href="${PageLinks.privacy_policy}">privacy policy</a> and <a href="/${PageLinks.cookie_policy}/">cookie policy</a>. <br /><br />This site is protected by reCAPTCHA and the Google <a href="${PageLinks.privacy_policy}">Privacy Policy</a> and <a href="${PageLinks.terms_condition}" target="_blank">Terms of Service</a> apply.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/julianwaddenestateagency/",
    tw_link: "",
    company_phone: "",
    available_time: "We're available from 9- 5pm Monday to Friday.",
    address: "70 St. Mary Axe, London, EC3A 8BE"
}

export const PopularSearch_Areas = [
    { value: "south-manchester", label: "South Manchester" },
    { value: "didsbury", label: "Didsbury" },
    { value: "marple", label: "Marple" },
    { value: "stockport", label: "Stockport" }
]
export const PopularSearch_Branches = [
    { value: "didsbury-estate-agents", label: "Didsbury" },
    { value: "marple-estate-agents", label: "Marple" },
    { value: "stockport-estate-agents", label: "Stockport" },
    { value: "the-heatons-estate-agents", label: "Heaton Moor" }
]

// export const PageLinks = {
//     about: "about-dj-alexander",
//     general_enquiry: "general-enquiry",
//     news_insight: "about-dj-alexander/insights",
//     branch_finder: "about-dj-alexander/branch-finder",
//     area_cover: "about-dj-alexander/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-dj-alexander/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-dj-alexander/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: "financial-services"
// }

export const PropertySearchURL = {
    residential: {
        sales: "/property/for-sale/",
        lettings: "/property/to-rent/",
        students: "/property-students/to-rent/",
        newhomes: "/new-homes/for-sale/",
        newdevelopments: "/new-developments/for-sale/",
        investments: "/property-investments/for-sale/",
        students: "/property-students/to-rent/",
        collection: "/property-collection/for-sale/",
        exceptional: "/property-exceptional/for-sale/",
    },
    commercial: {
        sales: "/commercial-property/for-sale/",
        lettings: "/commercial-property/to-rent/",
    },
    auction: {
        sales: "/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales: "/property-for-sale/",
        lettings: "/property-to-rent/",
        newhomes: "/property-for-sale/",
        newdevelopments: "/new-developments-for-sale/"
    },
    commercial: {
        sales: "/commercial-property-for-sale/",
        lettings: "/commercial-property-to-rent/",
    },
    auction: {
        sales: "/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales: "Properties for sale",
        lettings: "Properties to rent",
        newhomes: "New homes",
        newdevelopments: "New developments",
        investments: "Investment properties for sale",
        students: "Student properties for sale",
        collection: "Collection properties for sale",
        exceptional: "Exceptional homes for sale",
    },
    commercial: {
        sales: "Commercial properties for sale",
        lettings: "Commercial properties to rent",
    },
    auctions: {
        sales: "Auction properties for sale"
    }
}

export const PopularSearch_Types = [
    { value: "detached", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
]

export const sortByList = [
    { value: "Newest", label: "Most Recent" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" },
    { value: "Oldest", label: "Oldest" }
]

export const SearchType = {
    sales: "For Sale",
    lettings: "To Rent",
    newhomes: "New homes",
    investments: "Investments",
    students: "Students",
    commercial_sales: "Commercial Sales",
    commercial_lettings: "Commercial Lettings",
    auction_sales: "Auctions",
    collection: "Collection",
    exceptional: "Exceptional",
    newdevelopments: "New Developments",
}

export const FurnishedType = [
    { value: '', label: 'Select type' },
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const DepartmentType = [
    { value: '', label: 'Select type' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
]

// export const leadooPageSlot = {
//     sell_property:"Sellers",
//     landlords:"Landlords",
//     sales:"Sale listing",
//     lettings:"Rental listing",
//     branch_finder:"Branch finder",
//     general_enquiry:"General enquiry",
//     valuation:"Valuation",
//     home:"Valuation"
// }